import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { NgxMaskModule } from 'ngx-mask';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { NegativeMaskDirective } from './directives/app-negative';
import { GerenciarCotaComponent } from './gerenciar-cota.component';

@NgModule({
  declarations: [GerenciarCotaComponent, NegativeMaskDirective],
  imports: [
    CommonModule,
    FormsModule,
    MatTreeModule,
    MatCardModule,
    MatTableModule,
    MatInputModule,
    BrowserAnimationsModule,
    NgxMaskModule.forChild(),
    BrowserModule,
    MatButtonModule,
    MatIconModule,
    MatBadgeModule,
    MatTooltipModule,
    MatSnackBarModule,
    CurrencyMaskModule,
    MatProgressSpinnerModule,
    ScrollingModule,
    NgxSkeletonLoaderModule,
  ],
  exports: [GerenciarCotaComponent],
})
export class GerenciarCotaModule {}
